const Page404 = () => {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-2xl font-bold">Stránka nebyla nalezena</h1>
        <p className="text-gray-600">Požadovaná stránka neexistuje.</p>
      </div>
    </div>
  );
};
export default Page404;
